import { Header, Main } from '@pcrm/fe/ui-kit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/')({
  component: AcasaPagina,
});

/**
 * Acasă. Ținta brandului din sidebar și a redirectării de după login.
 *
 * A fost „Stare sistem" — pagina de probă a schelei (tichetul #41): chema `/health` și
 * genera un PDF, ca să dovedească faptul că aplicația chiar vorbește cu serverul. Și-a
 * făcut treaba, dar nu era un ecran de produs, iar în meniu arăta ca unul. Verificările
 * s-au mutat în indicatoarele din piciorul sidebar-ului, unde se văd fără să navighezi
 * nicăieri (fondatorul, #48).
 *
 * Rămâne goală **intenționat**, până când există un tablou de bord de pus aici. Un ecran
 * plin de cutii inventate ar fi mai rău decât unul care spune ce urmează: primul se
 * raportează ca defect, al doilea nu.
 */
function AcasaPagina() {
  return (
    <>
      <Header fixed>
        <h1 className="text-lg font-semibold">Acasă</h1>
      </Header>

      <Main id="content">
        <p className="text-muted-foreground">
          Ecranele de lucru intră odată cu epicile următoare. Până atunci, zona construită e în{' '}
          <span className="font-medium text-foreground">Setări</span>.
        </p>
      </Main>
    </>
  );
}
